/** @jsxImportSource @emotion/react */
import { Input } from '@quickbit/qb-design-system';

interface Props {
  label?: string;
  value?: string;
  onChange: (value: string) => void;
  error: string | undefined;
}

export const ColorInput = ({ error, label, value, onChange }: Props) => {
  return (
    <Input
      label={label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      endAdornment={
        <div
          css={{
            width: '20px',
            height: '20px',
            backgroundColor: value || 'transparent',
          }}
        />
      }
      error={!!error}
      helperText={error || ''}
    />
  );
};
